<style>
  /* Force widget background colors with maximum specificity */
  section.card.dashboard-widget-card.widget-bg-green,
  section.card.widget-bg-green {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-red,
  section.card.widget-bg-red {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-blue,
  section.card.widget-bg-blue {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  section.card.dashboard-widget-card.widget-bg-purple,
  section.card.widget-bg-purple {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-radius: 35px !important;
  }
  
  /* Make card-heading transparent for widget cards */
  .dashboard-widget-card .card-heading,
  section.card.dashboard-widget-card .card-heading,
  .widget-bg-green .card-heading,
  .widget-bg-red .card-heading,
  .widget-bg-blue .card-heading,
  .widget-bg-purple .card-heading {
    background: transparent !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }
  
  /* Dashboard widget cards — flat, no drop shadow */
  .company-news-card,
  .allMeetings,
  .my-task {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }

  .company-news-card:hover,
  .allMeetings:hover,
  .my-task:hover {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }
</style>
<ng-container *ngIf="!isUPSILiteActive">
<div class="dashboard-page dashboard-root" [class.dashboard-page--edit-layout]="dashboardEditMode">
<div class="clearfix"></div>

<div class="dashboard-layout-toolbar alert alert-info d-flex flex-wrap align-items-center justify-content-between mb-3"
     *ngIf="dashboardEditMode" role="status">
  <span class="mb-2 mb-md-0"><i class="fa fa-pencil mr-2"></i>Drag widgets to reorder. Adjust width, visibility, then save.</span>
  <div class="dashboard-layout-toolbar__actions">
    <button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="onResetDashboardLayout()">Reset</button>
    <button type="button" class="btn btn-sm btn-outline-secondary mr-2" (click)="onCancelDashboardLayoutEdit()">Cancel</button>
    <button type="button" class="btn btn-sm btn-primary" (click)="onSaveDashboardLayout()" [disabled]="layoutSaveInProgress">
      {{ layoutSaveInProgress ? 'Saving…' : 'Save layout' }}
    </button>
  </div>
</div>

<div class="row dashboard-layout-grid"
     cdkDropList
     [cdkDropListDisabled]="!dashboardEditMode"
     (cdkDropListDropped)="onLayoutDrop($event)">
  <ng-container *ngFor="let w of displayLayoutWidgets; trackBy: trackLayoutWidget">
    <div
      class="dashboard-layout-item col-12 mb-3"
      [ngClass]="'col-lg-' + w.colSpan"
      [class.dashboard-layout-item--hidden-edit]="dashboardEditMode && !w.visible"
      cdkDrag
      [cdkDragDisabled]="!dashboardEditMode">
      <app-dashboard-widget-shell
        [widget]="w"
        [meta]="getWidgetMeta(w.id)"
        [editMode]="dashboardEditMode"
        [chromeInViewMode]="false"
        (colSpanChange)="onWidgetColSpanChange(w.id, $event)"
        (visibleChange)="onWidgetVisibleChange(w.id, $event)"
        (collapsedToggle)="onWidgetCollapsedToggle(w.id)">
        <ng-container [ngSwitch]="w.id">
          <ng-container *ngSwitchCase="'digibot'">
            <div class="chatbot-dashboard-card dashboard-section mb-0">
              <app-chatbot [dashboardWidget]="true"></app-chatbot>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'trading-window'">
            <div class="trade-window d-flex justify-content-between align-items-center flex-wrap dashboard-section mb-0"
                 *ngIf="showTradingWindowBar">
              <div class="leftblock"
                [appHasPermission]="{'Url': 'stockPrice', 'method':'get', 'menu': 'Dashboard'}">
                <div class="anch-pointer d-flex align-items-center flex-wrap">
                  <label class="mr-4">Trading Window:</label>
                  <div *ngIf="selectedStockExchange === 'BSE'; else tradingWindowNseTpl" class="mb-0">
                    <div class="row">
                      <div *ngIf="tradingWindowStatus=='Off'">
                        <span>ON</span>
                        <span class="tradeOff">OFF</span>
                      </div>
                      <div *ngIf="tradingWindowStatus=='On'">
                        <span class="tradeOff">ON</span>
                        <span>OFF</span>
                      </div>
                    </div>
                  </div>
                  <ng-template #tradingWindowNseTpl>
                    <div class="row mb-0">
                      <div *ngIf="tradingWindowStatus=='Off'">
                        <span>ON</span>
                        <span class="tradeOff">OFF</span>
                      </div>
                      <div *ngIf="tradingWindowStatus=='On'">
                        <span class="tradeOn">ON</span>
                        <span>OFF</span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'quick-actions'">
            <div class="row dashboard-widget-strip mb-0">
              <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col">
                <div [ngClass]="setSubCardClasses(1,2)"
                     [appHasPermission]="{'Url': 'stockPrice', 'method':'get', 'menu': 'Dashboard'}">
                  <section class="card dashboard-widget-card widget-bg-green" order-id="card-2">
                    <div class="card-heading widget-card-content" (click)="openDashboardModal('ShareInfoModal')">
                      <div class="widget-icon-wrapper widget-icon-green">
                        <img src="/assets/images/share-information.png" alt="share information" class="widget-icon">
                      </div>
                      <div class="widget-title">Share Information</div>
                      <div class="widget-arrow">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                    <div class="modal fade" id="ShareInfoModal" tabindex="-1" role="dialog">
                      <div class="modal-dialog modal-xl" role="document">
                        <div class="modal-content" style="background: transparent;">
                          <div class="modal-body">
                            <app-stock-price [data]="companyData"></app-stock-price>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <!-- Financials widget hidden temporarily — re-enable when needed
              <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col">
                <div [ngClass]="setSubCardClasses(1,2)"
                     [appHasPermission]="{'Url': 'financialResults', 'method':'get', 'menu': 'Dashboard'}">
                  <section class="card dashboard-widget-card widget-bg-red" order-id="card-2">
                    <div class="card-heading widget-card-content" (click)="openDashboardModal('FinancialsModal')">
                      <div class="widget-icon-wrapper widget-icon-red">
                        <img src="/assets/images/financials.png" alt="Financials" class="widget-icon">
                      </div>
                      <div class="widget-title">Financials</div>
                      <div class="widget-arrow">
                        <i class="fa fa-arrow-right"></i>
                      </div>
                    </div>
                    <div class="modal fade" id="FinancialsModal" tabindex="-1" role="dialog">
                      <div class="modal-dialog modal-xl" role="document">
                        <div class="modal-content" style="background: transparent;">
                          <div class="modal-body">
                            <app-financials></app-financials>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              -->
              <!-- Key Ratios widget hidden temporarily — re-enable when needed
              <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col"
                   [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
                <section class="card dashboard-widget-card widget-bg-blue" order-id="card-2">
                  <div class="card-heading widget-card-content" (click)="openDashboardModal('KeyRatiosModal')">
                    <div class="widget-icon-wrapper widget-icon-blue">
                      <img src="/assets/images/key-ratios.png" alt="KeyRatios" class="widget-icon">
                    </div>
                    <div class="widget-title">Key Ratios</div>
                    <div class="widget-arrow">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                  <div class="modal fade" id="KeyRatiosModal" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-xl" role="document">
                      <div class="modal-content" style="background: transparent;">
                        <div class="modal-body">
                          <app-key-ratios></app-key-ratios>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              -->
              <div class="col-12 col-md-6 col-lg-6 dashboard-widget-col"
                   [appHasPermission]="{'Url': 'keyRatios', 'method':'get', 'menu': 'Dashboard'}">
                <section class="card dashboard-widget-card widget-bg-purple" order-id="card-2">
                  <div class="card-heading widget-card-content" (click)="openDashboardModal('orgChartModal')">
                    <div class="widget-icon-wrapper widget-icon-purple">
                      <img src="/assets/images/organization-charts.png" alt="orgchart" class="widget-icon">
                    </div>
                    <div class="widget-title">Organization Chart</div>
                    <div class="widget-arrow">
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </section>
                <app-orgchart></app-orgchart>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'my-tasks'">
            <div class="company-news-meetings-row dashboard-widget-row mb-0" *ngIf="RowOne">
              <div class="cat__core__sortable w-100">
                <div [appHasPermission]="{'Url': 'myTasks', 'method':'get', 'menu': 'Dashboard'}">
                  <app-mytask [refreshStatus]="taskObject" (UpdatedStatus)="updatedTask($event)"></app-mytask>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'company-news'">
            <div class="company-news-meetings-row dashboard-widget-row mb-0" *ngIf="RowOne">
              <div class="cat__core__sortable w-100">
                <div [appHasPermission]="{'Url': 'companyNews', 'method':'get', 'menu': 'Dashboard'}">
                  <app-company-news></app-company-news>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'meetings'">
            <div class="dashboard-widget-row mb-0" *ngIf="RowFive || RowSix">
              <div class="cat__core__sortable w-100">
                <app-meeting-assistent-wrapper [refreshData]="taskObject" (outputStatus)="updatedTask($event)"
                    [rowFive]="RowFive" [rowSix]="RowSix" [isRocketChatRemove]="isRocketChatRemove">
                </app-meeting-assistent-wrapper>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </app-dashboard-widget-shell>
    </div>
  </ng-container>
</div>

<div class="row mb-3 dashboard-page esg" *ngIf="isPSSConfig" style="margin: 0;"></div>
</div>
</ng-container>
<!-- UPSI Lite: primary action — top-right toolbar (hidden for Guest Super Admin) -->
<div class="dashboard-upsi-lite" *ngIf="isUPSILiteActive && !isGuestSuperAdminUser">
  <div class="dashboard-upsi-lite__toolbar">
    <button
      type="button"
      class="btn dashboard-upsi-lite__add-btn"
      (click)="navigateToAddUpsiDetails()">
      <i class="fa fa-plus dashboard-upsi-lite__add-icon" aria-hidden="true"></i>
      <span>Add UPSI Details</span>
    </button>
  </div>
</div>
<!-- Welcome message when dashboard is not enabled -->
<div class="tab-content" *ngIf="!enableDashboard && !isUPSILiteActive">
  <section style="background-color: white">
    <h2>Welcome</h2>
  </section>
</div>
<!-- Loading spinner overlay -->
<div *ngIf="showSpinner" style="background-color:transparent"></div>
<!-- Footer (outside dashboard row) -->
<footer class="footer">
  <!-- Footer content here -->
</footer>
